import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'
import QRCode from "qrcode.react"

import DeleteModal from 'pages/parts/DeleteModal'
import { returnSign, findKeyFromArrayByValue, notify, copyText } from "helpers/helpers";
import { httpOk, GET, POST, DELETE, FILE, PUT } from 'helpers/api'
import { smiles } from "helpers/smiles"
import { renderSortIndicator, patchSortFilterOnColumnClick } from 'helpers/tableSortIndicator'
import HintIcon from 'pages/parts/HintIcon'

function Index() {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)

	const statuses = [
		{ "id": 1, "name": t('success') },
		{ "id": -1, "name": t('deleted') },
	]

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [selectedItem, setSelectedItem] = useState({ 'name': '', 'showSmiles': false })
	const [showModal, setShowModal] = useState(false)
	const [showModalCalculation, setShowModalCalculation] = useState(false)
	const [modalPoses, setModalPoses] = useState(false)
	const [menuPoses, setMenuPoses] = useState([])
	const [showQrModal, setShowQrModal] = useState(false)
	const [showGallery, setShowGallery] = useState(false)
	const [qrValue, setQrValue] = useState("")
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [isImageDragOver, setIsImageDragOver] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		status: 1,
	})
	const [sortData, setSortData] = useState({ order_by: null, sort: 'asc' })
	const [collapsedIds, setCollapsedIds] = useState([])

	// сортировка по клику на заголовок: та же колонка — asc/desc, другая — новая колонка
	function handleSort(columnKey) {
		const next = patchSortFilterOnColumnClick(sortData, columnKey)
		setSortData({ order_by: next.order_by, sort: next.sort })
	}

	function toggleCollapse(id) {
		if (collapsedIds.includes(id)) {
			setCollapsedIds(collapsedIds.filter(item => item !== id))
		} else {
			setCollapsedIds([...collapsedIds, id])
		}
	}

	// дерево parent → child: дети идут сразу под своим родителем, сортировка внутри уровня
	const treeData = useMemo(() => {
		function compareItems(a, b) {
			if (!sortData.order_by) return 0
			var direction = sortData.sort === 'desc' ? -1 : 1
			var first = a[sortData.order_by]
			var second = b[sortData.order_by]

			if (sortData.order_by === 'products_count')
				return (Number(first || 0) - Number(second || 0)) * direction

			if (sortData.order_by === 'is_external_menu_enabled')
				return ((first ? 1 : 0) - (second ? 1 : 0)) * direction

			return String(first ?? '').localeCompare(String(second ?? ''), undefined, { numeric: true, sensitivity: 'base' }) * direction
		}

		var ids = data.map(element => element.id)
		var childrenByParent = {}
		var roots = []
		for (let i = 0; i < data.length; i++) {
			var item = data[i]
			var hasParent = item.parent_id && ids.includes(item.parent_id) && item.parent_id !== item.id
			if (hasParent) {
				if (!childrenByParent[item.parent_id]) childrenByParent[item.parent_id] = []
				childrenByParent[item.parent_id].push(item)
			} else {
				roots.push(item)
			}
		}

		var rows = []
		var visited = []
		function walk(items, level, prefix, hidden) {
			var sorted = [...items].sort(compareItems)
			sorted.forEach((element, index) => {
				if (visited.includes(element.id)) return // защита от циклических parent_id
				visited.push(element.id)

				var number = prefix ? prefix + '.' + (index + 1) : String(index + 1)
				var children = childrenByParent[element.id] || []
				rows.push({
					...element,
					'level': level,
					'number': number,
					'has_children': children.length > 0,
					'hidden': hidden,
				})
				if (children.length)
					walk(children, level + 1, number, hidden || collapsedIds.includes(element.id))
			})
		}
		walk(roots, 0, '', false)

		return rows
	}, [data, sortData, collapsedIds])

	async function createUpdate(e) {
		e.preventDefault();

		var selectedItemCopy = { ...selectedItem }

		var response;
		if (selectedItemCopy.id) {
			response = await PUT('/menu', selectedItemCopy, { loader: true })
		} else {
			response = await POST('/menu', selectedItemCopy, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModal()
			toggleModalCalculation()
		}
	}

	async function searchWithFilter() {
		var filterUrl = "/menu"
		var urlParams = ""
		checkFilter()

		if (filterData.status)
			urlParams += returnSign(urlParams) + 'status=' + filterData.status

		if (`/menu${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setDropdownIsOpen(false)
		}
	}

	function resetFilter() {
		setFilterData({
			status: 1,
		})
		setFilterDataExist(false)
	}

	function checkFilter() {
		if (filterData.status === null) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	// Раздел меню по точкам: «этот зал торгует десертами». Пусто — раздел везде.
	async function toggleModalPoses(bool = false, item = {}) {
		setSelectedItem(item)
		setModalPoses(bool)
		if (!bool) return

		const response = await GET(`/menu-poses/${item.id}`, {}, { loader: true })
		if (httpOk(response)) setMenuPoses(response.data)
	}

	function toggleMenuPos(posId, isSelected) {
		setMenuPoses(menuPoses.map((pos) => (
			pos.pos_id === posId ? { ...pos, 'is_selected': isSelected } : pos
		)))
	}

	async function saveMenuPoses(e) {
		e.preventDefault()

		const response = await PUT('/menu-poses', {
			menu_id: selectedItem.id,
			pos_ids: menuPoses.filter((pos) => pos.is_selected).map((pos) => pos.pos_id),
		}, { loader: true })

		if (httpOk(response)) {
			setModalPoses(false)
			searchWithFilter()
		}
	}

	function toggleModal(bool = false, item = {}) {
		if (bool) setSelectedItem(item)
		if (!bool) {
			setShowGallery(false)
			setSelectedItem({ 'name': '' })
		}

		setShowModal(bool)
	}

	function toggleModalCalculation(bool = false, item = { 'calculation_type_id': 1 }) {
		if (bool) setSelectedItem(item)
		if (!bool) setSelectedItem(item)

		setShowModalCalculation(bool)
	}

	async function deleteItem() {
		const response = await DELETE('/menu', { 'id': deleteModalParams.id }, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	async function restoreItem(item) {
		var sendData = { ...item }
		sendData.id = item.id
		sendData.status = 1
		var response = await PUT('/menu-status', sendData, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	function getDefaultPosUuid(list = poses) {
		const defaultPos = list.find(option => Number(option.id) === Number(reduxAccount.pos_id))
			|| list.find(option => option.uuid)

		return defaultPos?.uuid || ''
	}

	function getQrMenuUrl(uuid = qrValue) {
		return uuid ? `https://service.mison.uz/menu/${uuid}` : ''
	}

	function copyQrMenuUrl() {
		const url = getQrMenuUrl()
		if (!url) return

		copyText(url)
		notify(t('copied'), 'success')
	}

	function openQrModal() {
		setQrValue(getDefaultPosUuid())
		setShowQrModal(true)
	}

	function downloadQRCode() {
		const canvas = document.getElementById("qr-gen");
		const pngUrl = canvas
			.toDataURL("image/png")
			.replace("image/png", "image/octet-stream");
		let downloadLink = document.createElement("a");
		downloadLink.href = pngUrl;
		downloadLink.download = 'qr.png';
		document.body.appendChild(downloadLink);
		downloadLink.click();
		document.body.removeChild(downloadLink);
	}

	async function uploadImageFile(file) {
		if (!file) return

		if (!file.type?.startsWith('image/')) {
			notify(t('image2'))
			return
		}

		let formData = new FormData();
		formData.append("id", selectedItem.id);
		formData.append("image", file);
		formData.append("path", 'menu');

		var response
		if (!selectedItem.id) {
			response = await FILE('/upload-image', formData, {}, { loader: true });
		} else {
			formData.append("db_name", 'menu');
			formData.append("column_name", 'image');
			response = await FILE(`/update-image`, formData, {}, { loader: true });
		}
		if (httpOk(response)) {
			setSelectedItem({ ...selectedItem, 'image': response.data.url })
		}
	}

	async function fileUpload(e) {
		await uploadImageFile(e.target.files[0])
	}

	async function handleImageDrop(e) {
		e.preventDefault()
		setIsImageDragOver(false)
		await uploadImageFile(e.dataTransfer.files[0])
	}

	async function getPoses() {
		const response = await GET('/pos', {})
		if (httpOk(response)) {
			setPoses(response.data)
		}
	}

	useEffect(() => {
		if (!showQrModal || qrValue) return

		const defaultUuid = getDefaultPosUuid()
		if (defaultUuid) setQrValue(defaultUuid)
	}, [showQrModal, poses, reduxAccount.pos_id]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
		getPoses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('menu')} [{data.length}]
				</h4>
				<div className="d-flex gap-2">
					<button className="btn-rounded btn btn-primary"
						onClick={openQrModal}>
						QR {t('menu')}
					</button>
					<button className="btn-rounded btn btn-primary"
						onClick={() => setShowModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}
										className="th-sortable user-select-none"
										onClick={() => handleSort('name')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-between gap-2 pe-1">
											<span>{t('name2')}</span>
											{renderSortIndicator('name', sortData)}
										</div>
									</th>
									<th style={{ 'width': '20%' }}
										className="th-sortable user-select-none"
										onClick={() => handleSort('parent_name')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-between gap-2 pe-1">
											<span>{t('menu')}</span>
											{renderSortIndicator('parent_name', sortData)}
										</div>
									</th>
									<th style={{ 'width': '5%' }}
										className="th-sortable user-select-none"
										onClick={() => handleSort('products_count')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-end gap-2 pe-1">
											<span>{t('products')}</span>
											{renderSortIndicator('products_count', sortData)}
										</div>
									</th>
									<th style={{ 'width': '15%' }}
										className="th-sortable user-select-none"
										onClick={() => handleSort('is_external_menu_enabled')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-center gap-2 pe-1">
											<span>{t('external_service')}</span>
											{renderSortIndicator('is_external_menu_enabled', sortData)}
										</div>
									</th>
									<th style={{ 'width': '55%' }}></th>
									<th style={{ 'width': '35px', 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{treeData.filter(item => !item.hidden).map((item, index) => (
									<tr key={item.id}>
										<td className="text-center">{item.number}</td>
										<td className="td-ellipsis" title={item.name}>
											<div className="d-flex align-items-center"
												style={{ 'paddingLeft': item.level * 20 }}>
												{item.has_children ?
													<i className={'uil ' + (collapsedIds.includes(item.id) ? 'uil-angle-right' : 'uil-angle-down')}
														style={{ 'fontSize': 18, 'lineHeight': 1, 'cursor': 'pointer', 'marginRight': 4 }}
														onClick={() => toggleCollapse(item.id)}></i>
													:
													<span style={{ 'display': 'inline-block', 'width': 18, 'marginRight': 4 }}></span>
												}
												<span style={{
													'whiteSpace': 'nowrap',
													'overflow': 'hidden',
													'textOverflow': 'ellipsis',
													'minWidth': 0,
												}}>{item.name}</span>
											</div>
										</td>
										<td className="td-ellipsis">{item.parent_name}</td>
										<td className="text-end">{item.products_count}</td>
										<td className="text-center">
											{item.is_external_menu_enabled ?
												<span className="bg-primary bg-border text-white">{t('yes')}</span>
												:
												<span className="bg-danger bg-border text-white">{t('no')}</span>
											}
										</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalCalculation(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('set_commision')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalPoses(true, item)}>
															<i className="uil-store-alt"></i>
															{t('menu_poses')}
														</div>
														{item.status === 1 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index });
																	setModalDelete(true)
																}}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
														{item.status === -1 &&
															<div className="table-dropdown-item"
																onClick={() => restoreItem(item)}>
																<i className="uil-history-alt"></i>
																{t('restore')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={modalPoses} animation={false} centered
				onHide={() => toggleModalPoses(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('menu_poses')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={saveMenuPoses} autoComplete="off">
						<div className="border rounded">
							<label className="d-flex align-items-center gap-2 border-bottom px-3 py-2 mb-0"
								style={{ cursor: 'pointer' }}>
								<input type="checkbox" className="form-check-input flex-shrink-0 mt-0"
									checked={menuPoses.length > 0 && menuPoses.every((pos) => pos.is_selected)}
									ref={(el) => {
										if (!el) return
										const selected = menuPoses.filter((pos) => pos.is_selected).length
										el.indeterminate = selected > 0 && selected < menuPoses.length
									}}
									onChange={(e) => setMenuPoses(menuPoses.map((pos) => ({ ...pos, 'is_selected': e.target.checked })))} />
								<span className="fw-600">{t('all_poses')}</span>
								<HintIcon text={t('menu_poses_scope_hint')} className="ms-auto" />
							</label>

							<div style={{ maxHeight: '320px', overflowY: 'auto' }}>
								{menuPoses.map((item, index) => (
									<label className={`d-flex align-items-center gap-2 px-3 py-2 mb-0 pos-sale-row
										${index === menuPoses.length - 1 ? '' : 'border-bottom'}`}
										style={{ cursor: 'pointer' }}
										key={item.pos_id}>
										<input type="checkbox" className="form-check-input flex-shrink-0 mt-0"
											checked={!!item.is_selected}
											onChange={(e) => toggleMenuPos(item.pos_id, e.target.checked)} />
										<span className="text-truncate">{item.name}</span>
									</label>
								))}
							</div>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalPoses(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<div className="position-relative">
								<input type="text" className="form-control" name="name" autoFocus
									value={selectedItem.name}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
								<div className="input-smile-icon"
									onClick={() => setSelectedItem({ ...selectedItem, 'showSmiles': !selectedItem.showSmiles })}>🙂</div>
								{selectedItem.showSmiles &&
									<div className="input-smile-wrapper">
										{smiles.map((item, index) => (
											<div key={index} onClick={() => setSelectedItem({ ...selectedItem, 'name': selectedItem.name + smiles[index] })}>
												{smiles[index]}
											</div>
										))}
									</div>
								}
							</div>
						</div>

						<div className="form-group">
							<label>{t('menu')}</label>
							<Select
								isClearable
								options={data}
								value={data.find(option => option.id === selectedItem.parent_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'parent_id': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<label>{t('image')}</label>
						<div
							className="con-upload position-relative"
							onDragOver={(e) => {
								e.preventDefault()
								setIsImageDragOver(true)
							}}
							onDragLeave={() => setIsImageDragOver(false)}
							onDrop={handleImageDrop}>
							<div className={"con-img-upload " + (showGallery ? 'd-none' : '')}>
								{selectedItem.image &&
									<div
										className="img-upload"
										style={{
											border: isImageDragOver ? '2px dashed #5b73e8' : undefined,
											background: isImageDragOver ? 'var(--dark-tint-primary, #eef2ff)' : undefined,
										}}>
										<button type="button" className="btn-x-file"
											onClick={() => setSelectedItem({ ...selectedItem, 'image': '' })}>
											<i className="uil-times"></i>
										</button>
										<img src={`https://backend.mison.uz/uploads/menu/${selectedItem.image}`}
											style={{ maxWidth: 'none', maxHeight: '100%' }} alt={selectedItem.image} />
									</div>
								}
								{!selectedItem.image &&
									<div
										className="con-input-upload"
										style={{
											border: isImageDragOver ? '2px dashed #5b73e8' : undefined,
											background: isImageDragOver ? 'var(--dark-tint-primary, #eef2ff)' : undefined,
										}}>
										<input type="file" onChange={(e) => fileUpload(e)} />
										<span className="text-input fz14">
											{t('image2')}
										</span>
									</div>
								}
							</div>
						</div>

						<div className="d-flex justify-content-between mt-2">
							<p className="fw-600 vertical-center">{t('external_service')}</p>
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input" name="is_external_menu_enabled"
									checked={selectedItem?.is_external_menu_enabled}
									onChange={(e) => setSelectedItem({
										...selectedItem,
										'is_external_menu_enabled': e.target.checked,
									})} />
							</div>
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!(selectedItem.name)}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			{/* QR MODAL */}
			<Modal show={showQrModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => setShowQrModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						QR
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group">
						<label>{t('pos')}</label>
						<Select
							options={poses.filter((option) => option.uuid)}
							value={poses.find(option => option.uuid === qrValue) || ''}
							onChange={(option) => setQrValue(option ? option.uuid : '')}
							placeholder=""
							noOptionsMessage={() => t('list_empty')}
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.uuid}
						/>
						{qrValue &&
							<>
								<label className="mt-3">URL</label>
								<div className="d-flex gap-2">
									<input
										type="text"
										readOnly
										className="form-control"
										value={getQrMenuUrl()}
									/>
									<button
										type="button"
										className="btn btn-outline-primary text-nowrap"
										onClick={copyQrMenuUrl}>
										{t('copy')}
									</button>
								</div>
							</>
						}
						{qrValue &&
							<div className="d-flex justify-content-center mt-3">
								<QRCode
									id="qr-gen"
									value={getQrMenuUrl()}
									size={300}
									level={"H"}
									includeMargin={true}
								/>
							</div>
						}
					</div>
					<div className="d-flex w-100 mt-3">
						<button type="button" className="btn btn-primary w-100"
							onClick={() => downloadQRCode()}
							disabled={!(qrValue)}>
							{t('download')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* QR MODAL */}

			{/* MODAL CALCULATION */}
			<Modal show={showModalCalculation} animation={false} centered
				onHide={() => toggleModalCalculation()}>
				<Modal.Header closeButton>
					<Modal.Title>
						QR
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="d-flex gap-3">
							<div className="form-check p-0">
								<div className="radio-round"
									onClick={() => setSelectedItem({ ...selectedItem, 'calculation_type_id': 1 })}
									style={{ 'backgroundColor': selectedItem.calculation_type_id === 1 ? 'black' : '' }}>
								</div>
								<span onClick={() => setSelectedItem({ ...selectedItem, 'calculation_type_id': 1 })}>
									{t('amount')}
								</span>
							</div>

							<div className="form-check p-0">
								<div className="radio-round"
									onClick={() => setSelectedItem({ ...selectedItem, 'calculation_type_id': 2 })}
									style={{ 'backgroundColor': selectedItem.calculation_type_id === 2 ? 'black' : '' }}>
								</div>
								<span onClick={() => setSelectedItem({ ...selectedItem, 'calculation_type_id': 2 })}>
									{t('percentage')}
								</span>
							</div>
						</div>

						<div className="form-group w-100">
							<label>{t('value')}</label>
							<input type="text" className="form-control" name="calculation_value" autoComplete="off"
								value={selectedItem.calculation_value ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'calculation_value': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>


						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalCalculation()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!(selectedItem.calculation_value)}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CALCULATION */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index